export const QUERY_COMBINATORS = [
  { name: "and", label: "AND", value: "and" },
  { name: "or", label: "OR", value: "or" },
];

export const QUERY_OPERATORS = [
  { name: "=", label: "=" },
  { name: "!=", label: "≠" },
  { name: "<", label: "<" },
  { name: "<=", label: "≤" },
  { name: ">", label: ">" },
  { name: ">=", label: "≥" },
  { name: "contains", label: "contains" },
  { name: "doesNotContain", label: "does not contain" },
  { name: "beginsWith", label: "begins with" },
  { name: "endsWith", label: "ends with" },
  { name: "in", label: "in" },
  { name: "notIn", label: "not in" },
  { name: "between", label: "between" },
  { name: "notBetween", label: "not between" },
  { name: "null", label: "is null" },
  { name: "notNull", label: "is not null" },
];

export const FIELD_QUERY_OPERATORS = [
  ...QUERY_OPERATORS,
  { name: "expr", label: "= expression" },
  { name: "case", label: "CASE WHEN" },
];

export const SESSION_START_PRESET = {
  combinator: "and",
  rules: [{ id: "preset-start", field: "ignition", operator: "=", value: "ON" }],
};

export const SESSION_END_PRESET = {
  combinator: "and",
  rules: [{ id: "preset-end", field: "ignition", operator: "=", value: "OFF" }],
};

export function emptyRuleGroup() {
  return { combinator: "and", rules: [] };
}

export function createRule(partial = {}) {
  return {
    id: `rule-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 5)}`,
    field: "",
    operator: "=",
    value: "",
    ...partial,
  };
}

export function createRuleGroup(partial = {}) {
  return {
    id: `group-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 5)}`,
    combinator: "and",
    rules: [],
    ...partial,
  };
}

export function isRuleGroup(item) {
  return item != null && Array.isArray(item.rules);
}

export function inferFieldType(fieldName) {
  if (/timestamp|time|date|_at$/i.test(fieldName)) return "datetime";
  if (/speed|fuel|odometer|temp|rpm|distance|score|minutes|used/i.test(fieldName)) return "number";
  if (/ignition|status/i.test(fieldName)) return "select";
  return "text";
}

export function datasetFieldsToQueryFields(fieldNames = []) {
  return fieldNames.map((name) => ({
    name,
    label: name.replace(/_/g, " "),
    inputType: inferFieldType(name),
    values:
      name === "ignition"
        ? [
            { name: "ON", label: "ON" },
            { name: "OFF", label: "OFF" },
          ]
        : name === "status"
          ? [
              { name: "active", label: "active" },
              { name: "inactive", label: "inactive" },
              { name: "on-leave", label: "on-leave" },
            ]
          : undefined,
  }));
}
